import { render, staticRenderFns } from "./TibBannerReasonInput.vue?vue&type=template&id=9a025dd6"
import script from "./TibBannerReasonInput.vue?vue&type=script&lang=js"
export * from "./TibBannerReasonInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports